<template>
	<div>
		<reqsType :baseUrlpath="baseUrlpath" :reqType="reqType"></reqsType>
	</div>

</template>

<script>
	import {
		queryUrl,
		doPost
	} from '@/api/index';
	import {
		Toast
	} from 'mint-ui';
	import reqsType from '@/components/reqsType.vue'
	export default {
		name:'物流带货',
		metaInfo: {
			title: '中东华人宝-物流带货',
			meta: [{
					name: 'keyWords',
					content: '物流带货'
				},
				{
					name: 'description',
					content: '货找人，人找货，同城跑腿，物流公司，物流特价，物流产品，物流专线'
				}
			]
		},
		components: {
			reqsType
		},
		data() {
			return {
				baseUrlpath: '',
				reqType: '1'
			}
		},
		created() {
			this.baseUrlpath = this.baseUrl;
			var inchina = localStorage.getItem('inChina');
			if(inchina == '1'){
				this.baseUrlpath = this.baseUrlCN;
			}
		},
		methods: {}
	}
</script>

<style scoped="scoped" lang="scss">

</style>